import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

export interface ILabel {
  key: string;
  value: string;
}

const StringInput: FunctionComponent<ILabel> = ({ key, value }) => {
  return (
    <label
      for={key}
      className="base-form__label"
    >
      {value}
    </label>
  );
};

export default StringInput;
